export const theme = 'sportscraft';

export const headerHeight = 62;
